(($) => {
    "use strict";

    $.enhancer("minorToggler", function () {
        const form = $(this);
        const minorField = form.find('#AttendeeFormData_SecurityNumber');
        const addressContainer = form.find('[data-minortoggler-target]');

        minorField.on('keyup change blur input',
            (e) => {
                if (minorField.valid()) {
                    setAddressVisibility(requiresAddress(minorField.val()));
                }
            });

        if (minorField.val() !== undefined && minorField.val() !== "") {
            minorField.trigger('change');
        }

        function setAddressVisibility(visibility) {
            if (visibility) {
                addressContainer.show();
            } else {
                addressContainer.hide();
            }
        }

        function requiresAddress(value) {
            var day = "";

            if (value.length >= 12) {
                value = value.substr(0, 4) + "-" + value.substr(4, 2) + "-" + value.substr(6, 2);
                day = value.substr(8, 2);
            } else if (value.length >= 6) {
                value = value.substr(0, 2) + "-" + value.substr(2, 2) + "-" + value.substr(2, 2);
                day = value.substr(6, 2);
            }

            if (isDate(value)) {
                return getYears(new Date(value), Date.now()) <= 18;
            } else {
                if (day > "31") {
                    return true;
                }
            }

            return false;

        }

        function isDate(val) {
            var d = new Date(val);
            
            return !isNaN(d.valueOf());
        }

        function getYears(from, to) {
            var d1 = new Date(from),
                d2 = new Date(to);

            return d2.getFullYear() - d1.getFullYear();
        }

    });
})(jQuery);